import React, { useState } from "react";
import { withRouter } from "react-router";
import AppContainer from "../AppContainer/AppContainer";

import "./quality-check.scss";

const HubOutQualityCheck = () => {

    const [qualityChecked, setQualityChecked] = useState(false);
    const [collectionBagged, setCollectionBagged] = useState(false);
    const [tagAttached, setTagAttached] = useState(false);
    const [tagScanned, setTagScanned] = useState(false);

    function toggleQualityChecked() {
        setQualityChecked(!qualityChecked);
    }
    function toggleCollectionBagged() {
        setCollectionBagged(!collectionBagged);
    }
    function toggleTagAttached() {
        setTagAttached(!tagAttached);
    }
    function toggleTagScanned() {
        setTagScanned(!tagScanned);
    }

    return (
        <AppContainer>
            <div class="formContainer">
                <div class="formObject withBorder title">COLLECTOR TO COMPLETE</div>
                <div class="formObject">
                    <div className={"checkbox"}>
                        <i onClick={toggleQualityChecked} className={"fal " + (qualityChecked ? "fa-check-square" : "fa-square")}></i>
                    </div>
                    <div class="checkboxLabel">Quality Checked</div>
                </div>
                <div class="formObject">
                    <div className={"checkbox"}>
                        <i onClick={toggleCollectionBagged} className={"fal " + (collectionBagged ? "fa-check-square" : "fa-square")}></i>
                    </div>
                    <div class="checkboxLabel">Collection Bagged</div>
                </div>
                <div class="formObject">
                    <div className={"checkbox"}>
                        <i onClick={toggleTagAttached} className={"fal " + (tagAttached ? "fa-check-square" : "fa-square")}></i>
                    </div>
                    <div class="checkboxLabel">Security Tag Attached</div>
                </div>
                <div class="formObject">
                    <div className={"checkbox"}>
                        <i onClick={toggleTagScanned} className={"fal " + (tagScanned ? "fa-check-square" : "fa-square")}></i>
                    </div>
                    <div class="checkboxLabel">Security Tag Scanned</div>
                </div>
                <div class="formObject centred withBorder accept">LOG PICK-UP</div>
            </div>
        </AppContainer>
    );
}

export default withRouter(HubOutQualityCheck);